import { render, staticRenderFns } from "./TutorialSumoBall.vue?vue&type=template&id=38d1d728&scoped=true&"
var script = {}
import style0 from "./TutorialSumoBall.vue?vue&type=style&index=0&id=38d1d728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d1d728",
  null
  
)

component.options.__file = "TutorialSumoBall.vue"
export default component.exports